"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconFilter = function IconFilter(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    className: (0, _classnames.default)('Icon', 'IconFilter', className),
    style: style
  }, _react.default.createElement("path", {
    id: "a",
    d: "M5.091 7.763l-4.94-5.84A.636.636 0 0 1 .638.874h12.726c.541 0 .835.634.485 1.047l-4.94 5.841v5.2c0 .474-.497.781-.92.57L5.443 12.26a.636.636 0 0 1-.352-.569V7.763zm6.9-5.615H2.01l4.204 4.971c.097.115.15.26.15.411v3.768l1.273.636V7.53c0-.15.054-.296.15-.41l4.205-4.972z"
  }));
};

var _default = IconFilter;
exports.default = _default;